import { useMutation, useQuery,useInfiniteQuery } from '@tanstack/react-query'
import { toast } from 'components/ui/use-toast'
import queryClient from 'config/tanstackQuery'
import { useNavigate } from 'react-router-dom'
import requests from 'service/api'



export function useOrderList({ status, search = '' }) {
  return useInfiniteQuery({
    queryKey: ['getOrders', status, search],
    queryFn: async ({ pageParam = 1 }) => {
      console.log("Fetching page:", pageParam);
      const response = await requests.order.list(status, pageParam, search);
      console.log("API Response:", response);

      return response.data;
    },
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.length < 30 ? undefined : allPages.length + 1;
    },
  });
}
export function useOrderDetail(orderNo) {
  return useQuery({
    queryKey: ['/get', orderNo],
    queryFn: async () => {
      const response = await requests.order.get(orderNo)
      return response.data
    },
    placeholderData: {}
  })
}

export function useOrderSave() {
  const navigate = useNavigate()
  return useMutation({
    mutationFn: async (body) => await requests.order.create(body),
    onSuccess: ({ data }) => {
      if (data) {
        navigate(`/siparisler/ekle/${data.path}/${data.id}`)
        setTimeout(() => {
          window.location.reload()
        }, 500)
        toast.success('Sipariş başarıyla kaydedildi')
      }
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}

export function useOrderWarningSave() {
  const navigate = useNavigate()
  return useMutation({
    mutationFn: async (body) => await requests.order.createwarning(body),
    onSuccess: ({ data }) => {
      if (data) {
        navigate(`/siparisler/ekle/${data.path}/${data.id}`)
        setTimeout(() => {
          window.location.reload()
        }, 500)
        toast.success('Sipariş başarıyla kaydedildi')
      }
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}

export function useOrderCordSave() {
  const navigate = useNavigate()
  return useMutation({
    mutationFn: async (body) => await requests.order.createcord(body),
    onSuccess: ({ data }) => {
      if (data) {
        navigate(`/siparisler/ekle/${data.path}/${data.id}`)
        setTimeout(() => {
          window.location.reload()
        }, 500)
        toast.success('Sipariş başarıyla kaydedildi')
      }
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}
export function useOrderAddionalSave() {
  const navigate = useNavigate()
  return useMutation({
    mutationFn: async (body) => await requests.order.createaddional(body),
    onSuccess: ({ data }) => {
      if (data) {
        navigate(`/siparisler/ekle/${data.path}/${data.id}`)
        setTimeout(() => {
          window.location.reload()
        }, 500)
        toast.success('Sipariş başarıyla kaydedildi')
      }
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}
export function useOrderemptySave() {
  const navigate = useNavigate()
  return useMutation({
    mutationFn: async (body) => await requests.order.createempty(body),
    onSuccess: ({ data }) => {
      if (data) {
        navigate(`/siparisler/ekle/${data.path}/${data.id}`)
        setTimeout(() => {
          window.location.reload()
        }, 500)
        toast.success('Sipariş başarıyla kaydedildi')
      }
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}
export function useOrderPriceSave() {
  const navigate = useNavigate()
  return useMutation({
    mutationFn: async (body) => await requests.order.createprice(body),
    onSuccess: ({ data }) => {
      if (data) {
        navigate(`/siparisler/ekle/${data.path}/${data.id}`)
        setTimeout(() => {
          window.location.reload()
        }, 500)
        toast.success('Sipariş başarıyla kaydedildi')
      }
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}

export function useOrderBeltSave() {
  const navigate = useNavigate()
  return useMutation({
    mutationFn: async (body) => await requests.order.createbelt(body),
    onSuccess: ({ data }) => {
      if (data) {
        navigate(`/siparisler/ekle/${data.path}/${data.id}`)
        setTimeout(() => {
          window.location.reload()
        }, 500)
        toast.success('Sipariş başarıyla kaydedildi')
      }
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}
export function useOrderBrandSave() {
  const navigate = useNavigate()
  return useMutation({
    mutationFn: async (body) => await requests.order.createbrand(body),
    onSuccess: ({ data }) => {
      if (data) {
        navigate(`/siparisler/ekle/${data.path}/${data.id}`)
        setTimeout(() => {
          window.location.reload()
        }, 500)
        toast.success('Sipariş başarıyla kaydedildi')
      }
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}


export function useOrderCopy() {
  return useMutation({
    mutationFn: async (id) => await requests.order.copyOrder(id),
    onSuccess: ({ data }) => {
      if (data) {
        const url = `/siparisler/ekle/${data.path}/${data.id}`
        window.open(url, '_blank')
        toast.success('Sipariş başarıyla kopyalandı.')
      }
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}

export function useOrderUpdate() {
  return useMutation({
    mutationFn: async ({ id, body }) => await requests.order.update(id, body),
    onSuccess: () => {
      toast.success('Güncelleme başarılı.')
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}

export function useOrderWarningUpdate() {
  return useMutation({
    mutationFn: async ({ id, body }) => await requests.order.updatewarning(id, body),
    onSuccess: () => {
      toast.success('Güncelleme başarılı.')
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}
export function useOrderCordUpdate() {
  return useMutation({
    mutationFn: async ({ id, body }) => await requests.order.updatecord(id, body),
    onSuccess: () => {
      toast.success('Güncelleme başarılı.')
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}
export function useOrderAddionalUpdate() {
  return useMutation({
    mutationFn: async ({ id, body }) => await requests.order.updateaddional(id, body),
    onSuccess: () => {
      toast.success('Güncelleme başarılı.')
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}
export function useOrderemptyUpdate () {
  return useMutation({
    mutationFn: async ({ id, body }) => await requests.order.updateempty(id, body),
    onSuccess: () => {
      toast.success('Güncelleme başarılı.')
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}
export function useOrderPriceUpdate() {
  return useMutation({
    mutationFn: async ({ id, body }) => await requests.order.updateprice(id, body),
    onSuccess: () => {
      toast.success('Güncelleme başarılı.')
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}

export function useOrderBeltUpdate() {
  return useMutation({
    mutationFn: async ({ id, body }) => await requests.order.updatebelt(id, body),
    onSuccess: () => {
      toast.success('Güncelleme başarılı.')
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}
export function useOrderBrandUpdate() {
  return useMutation({
    mutationFn: async ({ id, body }) => await requests.order.updatebrand(id, body),
    onSuccess: () => {
      toast.success('Güncelleme başarılı.')
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}
export function useOrderUpdateStatus() {
  return useMutation({
    mutationFn: async ({ id, body }) => await requests.order.updateStatus(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries(['/GetOrders'])
      toast.success('Güncelleme başarılı.')
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    }
  })
}

export function useArtworkOrder(orderNo, tab, zaratype, options = {}) {
  return useQuery({
    queryKey: ['/getArtworkOrder', orderNo, tab, zaratype],
    queryFn: async () => {
      console.log('API isteği başlatılıyor:', { orderNo, tab, zaratype });
      try {
        if(zaratype === "ZaraHome"){
          console.log('ZaraHome API çağrısı yapılıyor');
          const response = await requests.order.getArtworkOrderHome(orderNo, tab);
          console.log('ZaraHome API yanıtı:', response);
          return response.data;
        } else {
          console.log('Normal API çağrısı yapılıyor');
          const response = await requests.order.getArtworkOrder(orderNo, tab);
          console.log('Normal API yanıtı:', response);
          return response.data;
        }
      } catch (error) {
        console.error('API isteği başarısız:', error);
        throw error;
      }
    },
    placeholderData: undefined,
    retry: 3,
    retryDelay: 1000,
    enabled: options.enabled !== false
  });
}
export function useCreatePDF() {
  return useMutation({
    mutationFn: async (pdfData) => {
      const response = await requests.pdf.createPDF(pdfData);
      const url = URL.createObjectURL(response.data);
      return url;
    }
  });
}